<template>
    <div class='position-wrap'>

<!--        主机设备定位-->
        <div class="position-info">
            <el-title title="主机设备定位"></el-title>
            <div class="positionList-box">
                <div class="positionList-item" :class="{'single-bg':bSingle(index)}" v-for="(item,index) in positionList" :key="index">
                    <div>{{item.attr_name}}</div>
                    <div>{{item.attr_value}}</div>
                </div>
            </div>
        </div>

<!--        设计方案-->
        <div class="design-method">
            <el-title title="设计方案"></el-title>
            <img src="@/assets/images/share_img/share_case.jpg" alt="">
        </div>

<!--        相关产品-->
        <div class="products">
            <el-title title="相关产品"></el-title>
            <div class="products-box">
                <div class="product-item" v-for="(item,index) in productList" :key="index">
                    <div class="imgbox" :style="'background-image:url(' + item.img + ')'"></div>
                    <div class="product-name">{{item.name}}</div>
                    <div class="product-type">{{item.type}}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import elTitle from './title'

export default {
    name: "position",

    // 组件注册
    components: {
        elTitle
    },
    data() {
        return {
            positionList:[
                {
                    attr_name:'外机',
                    attr_value:'阳台',
                },
                {
                    attr_name:'内机',
                    attr_value:'厨房',
                },
                {
                    attr_name:'壁挂炉',
                    attr_value:'触发',
                },
                {
                    attr_name:'新风机',
                    attr_value:'卫生间',
                },
                {
                    attr_name:'储能水箱',
                    attr_value:'设备间',
                },
                {
                    attr_name:'中央控制器',
                    attr_value:'电箱',
                },
                {
                    attr_name:'前置过滤器',
                    attr_value:'设备间',
                },
                {
                    attr_name:'中央净水机',
                    attr_value:'设备间',
                },
                {
                    attr_name:'中央饮水机',
                    attr_value:'设备间',
                },
            ] ,  // 主机设备定位
            productList:[
                {
                    img:'http://pro-mixed-tt.babycdn.com/aotest/uploads/shop/goods/16257078092186.jpg',
                    name:'电壁挂热水器',
                    type:'EWH-H10'
                },{
                    img:'http://pro-mixed-tt.babycdn.com/aotest/uploads/shop/goods/16257078092186.jpg',
                    name:'燃气热水器',
                    type:'JSQ31-VJSX'
                },{
                    img:'http://pro-mixed-tt.babycdn.com/aotest/uploads/shop/goods/16257078092186.jpg',
                    name:'淋雨花洒',
                    type:'FS-10A'
                },{
                    img:'http://pro-mixed-tt.babycdn.com/aotest/uploads/shop/goods/16257078092186.jpg',
                    name:'美容软水机',
                    type:'S20G1'
                }
            ]
        };
    },
    props: {},
    //计算属性
    computed: {

        bSingle (index) {
            return index => {
                return Math.ceil((index + 1) / 3) % 2 != 0
            }
        }
    },
    // 数据监听
    watch: {},
    //方法集合
    methods: {},
    //生命周期 - 创建完成
    created() {
    },
    //生命周期 - 挂载完成
    mounted() {
    },
}
</script>
<style lang='scss' scoped>
.flc {
    display: flex;
    justify-content: center;
    align-items: center;
}

.flc2 {
    display: flex;
    align-items: center;
}

.positionc {
    position: absolute;
    left: 50%;
    transform: translate(-50%);
}

.position-wrap {
    width: 100%;
    height: 100%;
    .position-info {
        background: #FFFFFF;
        padding-bottom: 32px;
        border-radius: 16px 16px 16px 16px;
        margin-bottom: 16px;
        .positionList-box {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            .positionList-item {
                height: 116px;
                padding: 16px 0 0 48px;
                div:nth-child(1) {
                    font-size: 24px;
                    font-weight: 400;
                    color: #999999;
                    margin-bottom: 8px;
                }
                div:nth-child(2) {
                    font-size: 24px;
                    font-weight: 500;
                    color: #333333;
                }
            }
            .single-bg {
                background: #F9F9FB;
            }
        }
    }
    .design-method {
        background-color: #fff;
        border-radius: 16px 16px 16px 16px;
        padding-bottom: 32px;
        margin-bottom: 16px;
        img {
            width: 100%;
            height: 482px;
        }
    }
    .products {
        background-color: #fff;
        border-radius: 16px 16px 16px 16px;
        padding-bottom: 32px;
        margin-bottom: 16px;
        .products-box {
            display: grid;
            grid-template-columns:repeat(3,1fr);
            column-gap: 56px;
            row-gap: 32px;
            padding: 0 48px;
            .product-item {
                height: 240px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                .imgbox {
                    width: 100%;
                    height: 160px;
                    background-color:rgba(51, 90, 77,0.05);
                    border-radius: 12px;
                    background-size: 44%;
                    background-position:center center ;
                    background-repeat:no-repeat;
                }
                .product-name {
                    margin: 16px 0 8px;
                    font-size: 24px;
                    font-weight: 400;
                    color: #999999;
                }
                .product-type {
                    font-size: 24px;
                    font-weight: 500;
                    color: #333333;
                }
            }
        }
    }
}
</style>
